import toast from "react-hot-toast";

import { AlertToast } from "./AlertToast/AlertToast";
import { TOAST_DURATION } from "./Toaster";
import { Notify } from "./types";

export const notify: Notify = {
  alert: {
    loading: (content, options) => {
      return toast.custom(
        (t) => (
          <AlertToast rhtToastProps={t} type={"loading"} content={content} />
        ),
        options
      );
    },
    success: (content, options) => {
      return toast.custom(
        (t) => (
          <AlertToast rhtToastProps={t} type={"success"} content={content} />
        ),
        options
      );
    },
    error: (content, options) => {
      return toast.custom(
        (t) => (
          <AlertToast rhtToastProps={t} type={"error"} content={content} />
        ),
        options
      );
    },
    warning: (content, options) => {
      return toast.custom(
        (t) => (
          <AlertToast rhtToastProps={t} type={"warning"} content={content} />
        ),
        options
      );
    },
    info: (content, options) => {
      return toast.custom(
        (t) => <AlertToast rhtToastProps={t} type={"info"} content={content} />,
        options
      );
    },
    stateful: (content, options) => {
      const toastId = toast.custom(
        (t) => (
          <AlertToast rhtToastProps={t} type={"loading"} content={content} />
        ),
        {
          duration: Infinity,
          ...options,
        }
      );
      return {
        id: toastId,
        update: (type, content, options) => {
          return toast.custom(
            (t) => (
              <AlertToast rhtToastProps={t} type={type} content={content} />
            ),
            {
              id: toastId,
              duration: TOAST_DURATION,
              ...options,
            }
          );
        },
      };
    },
  },
  dismiss: (toastId: string) => {
    toast.dismiss(toastId);
  },
  remove: (toastId: string) => {
    toast.remove(toastId);
  },
};
